import { useCallback, useEffect, useState } from "react";
import refreshLottie from "assets/lottie/loader.json";

import { useLogto } from "@logto/react";
import { Box } from "@mui/material";
import Lottie from "lottie-react";
import { useSearchParams } from "react-router-dom";
export const InvitationHandler = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { signIn, isAuthenticated, isLoading } = useLogto();

  useEffect(() => {
    signInHandler();
  }, [isAuthenticated, searchParams]);

  const signInHandler = useCallback(() => {
    // Extract the token and email from the magic link
    const oneTimeToken = searchParams.get("token");
    const email = searchParams.get("email");
    const invitationId = searchParams.get("invitation_id");

    const redirectUri = `${window.location.origin}/callback`;
    const redirectUriCustomer = `${window.location.origin}/agent-activation-success`;

    if (oneTimeToken && email && window.location.pathname === "/invite") {
      signIn({
        redirectUri,
        // clearTokens: true,
        extraParams: {
          one_time_token: oneTimeToken,
          login_hint: email,
        },
      });
    } else if (
      oneTimeToken &&
      email &&
      window.location.pathname === "/invite-user"
    ) {
      signIn({
        redirectUri: redirectUriCustomer,
        // clearTokens: true,
        extraParams: {
          one_time_token: oneTimeToken,
          login_hint: email,
        },
      });
    }
  }, [searchParams]);

  return (
    <Box
      sx={{
        position: "absolute",
        top: "225px",
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "#FFF",
        zIndex: 1000000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "520px", height: "520px" }}>
        <Lottie animationData={refreshLottie} loop={true} />
      </Box>
    </Box>
  );
};
